"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Route_exports = {};
__export(Route_exports, {
  Route: () => Route,
  RouteParamsContext: () => RouteParamsContext,
  SuspenseFallbackContext: () => SuspenseFallbackContext,
  useContextKey: () => useContextKey,
  useRouteNode: () => useRouteNode
});
module.exports = __toCommonJS(Route_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"), 1);
var import_findFocusedRoute = require("../fork/findFocusedRoute");
var import_linkingConfig = require("./linkingConfig");
var import_matchers = require("./matchers");
var import_params = require("./params");
var import_path = require("./path");
var import_router = require("./router");
var import_RouteInfoContext = require("./RouteInfoContext");
var RouteParamsContext = /* @__PURE__ */ (0, import_react.createContext)({});
var CurrentRouteContext = /* @__PURE__ */ import_react.default.createContext(null);
var SuspenseFallbackContext = /* @__PURE__ */ (0, import_react.createContext)(void 0);
if (process.env.NODE_ENV !== "production") {
  CurrentRouteContext.displayName = "RouteNode";
  SuspenseFallbackContext.displayName = "SuspenseFallback";
}
function useRouteNode() {
  return (0, import_react.useContext)(CurrentRouteContext);
}
function useContextKey() {
  var node = useRouteNode();
  if (node == null) {
    throw new Error("No filename found. This is likely a bug in router.");
  }
  return (0, import_matchers.getContextKey)(node.contextKey);
}
function getParamsFromCurrentUrl(route) {
  var linking = (0, import_linkingConfig.getResolvedLinking)();
  if (!(linking === null || linking === void 0 ? void 0 : linking.getStateFromPath)) return void 0;
  var path = (0, import_path.getPathWithRecoveredDynamicSegment)([
    import_router.routeInfo === null || import_router.routeInfo === void 0 ? void 0 : import_router.routeInfo.unstable_globalHref,
    route === null || route === void 0 ? void 0 : route.path
  ]);
  if (!path) return void 0;
  var state = linking.getStateFromPath(path, linking.config);
  if (!state) return void 0;
  var focused = (0, import_findFocusedRoute.findFocusedRoute)(state);
  return focused === null || focused === void 0 ? void 0 : focused.params;
}
function Route(param) {
  var { children, node, route } = param;
  var parentParams = (0, import_react.useContext)(RouteParamsContext);
  var resolvedParams = import_react.default.useMemo(function() {
    var _node_dynamic;
    var rp = route === null || route === void 0 ? void 0 : route.params;
    var ownParams = ((_node_dynamic = node.dynamic) === null || _node_dynamic === void 0 ? void 0 : _node_dynamic.length) ? (0, import_params.mergeDynamicParams)(rp, node.dynamic, getParamsFromCurrentUrl(route)) : rp;
    if (!parentParams) return ownParams;
    if (!ownParams) return parentParams;
    return {
      ...parentParams,
      ...ownParams
    };
  }, [
    node,
    parentParams,
    route,
    import_router.routeInfo === null || import_router.routeInfo === void 0 ? void 0 : import_router.routeInfo.unstable_globalHref
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RouteParamsContext.Provider, {
    value: resolvedParams,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CurrentRouteContext.Provider, {
      value: node,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_RouteInfoContext.RouteInfoContextProvider, {
        children
      })
    })
  });
}
//# sourceMappingURL=Route.js.map
